import { render, staticRenderFns } from "./ContentTitle.vue?vue&type=template&id=4b4a1772&scoped=true&"
import script from "./ContentTitle.vue?vue&type=script&lang=js&"
export * from "./ContentTitle.vue?vue&type=script&lang=js&"
import style0 from "./ContentTitle.vue?vue&type=style&index=0&id=4b4a1772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4a1772",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
